export default __webpack_public_path__ + "static/media/virtual-tourMOB.ea2ab047.png";